// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___3LCyZ","forgotPassword":"styles-module__forgotPassword___QyGbq","sectionDivider":"styles-module__sectionDivider___1UbJ7"};